import React, { useMemo } from 'react';
import { Box, Chip, MenuItem, Select } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { PageHeader, AdminDataGrid } from '../../../components/admin';
import { useHydrantZavadyQuery, useUpdateZavadaMutation } from '../../../api/JsdhNotifikaceService/service/HydrantBodMutations';
import { ZavadaStav } from '../../../api/JsdhNotifikaceService/generated/models/HydrantBod';

const HydrantZavadyPage: React.FC = () => {
  const { data: zavady, isLoading } = useHydrantZavadyQuery();
  const update = useUpdateZavadaMutation();

  const columns: GridColDef[] = useMemo(() => [
    { field: 'popis', headerName: 'Popis', flex: 2 },
    { field: 'priorita', headerName: 'Priorita', width: 120,
      renderCell: (p) => <Chip size="small" label={p.value}
        color={p.value === 'KRITICKA' || p.value === 'VYSOKA' ? 'error' : 'default'} /> },
    {
      field: 'stav', headerName: 'Stav', width: 170,
      renderCell: (p) => (
        <Select size="small" value={p.value}
          onChange={(e) => update.mutate({ id: p.row.id, data: { stav: e.target.value as ZavadaStav } })}>
          <MenuItem value="NOVA">Nová</MenuItem>
          <MenuItem value="NAHLASENA">Nahlášena</MenuItem>
          <MenuItem value="V_RESENI">V řešení</MenuItem>
          <MenuItem value="VYRESENA">Vyřešena</MenuItem>
        </Select>
      ),
    },
  ], [update]);

  return (
    <Box>
      <PageHeader title="Závady hydrantů" subtitle="Evidence a stav řešení" />
      <AdminDataGrid rows={zavady ?? []} columns={columns} loading={isLoading} getRowId={(r) => r.id} />
    </Box>
  );
};

export default HydrantZavadyPage;
